module.exports = __webpack_public_path__ + "img/all.dfe77f9e.svg";